import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { FormCheck, FormControl, InputGroup, Container, Row, Col, Modal, Button } from 'react-bootstrap';
// , Dropdown, DropdownButton, SplitButton
import { apiUrl, searchUrl } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control, org_uuid, user_entity_uuid,
import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

import Select from 'react-select';

import geoLocation from 'utils/geoLocation';

import UserContext from 'store/UserContext';

import { slugify } from 'utils/Helper';

import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';

//import { useForm } from 'react-hubspot'

import './style.css';

function OnboardingModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const context = useContext(UserContext);

  const [step_name, setStepName] = useState('');
  const [loading, setLoading] = useState(false);
  const [city_options, setCityOptions] = useState([]);
  const [selected_city_option, setSelectedCityOption] = useState({});
  const [selected_occupation_category, setSelectedOccupationCategory] = useState({});
  const [message, setMessage] = useState(<React.Fragment></React.Fragment>);
  //const [user_info, setUserInfo] = useState(props.user_info);
  const [form_info, setFormInfo] = useState({});
  //const [input_jsx, setInputJsx] = useState(<React.Fragment></React.Fragment>);

  const occupation_categories = [
    {
      label: 'Hosting your own PechaKucha event',
      value: 'hosting event',
      hubspot_value: 'Hosting your own PechaKucha event'
    },
    {
      label: 'Using PechaKucha at your school as a student',
      value: 'using PechaKucha at school as a student',
      //hubspot_value: 'Using PechaKucha at your school as a student'
    },
    {
      label: 'Using PechaKucha at your school as a teacher',
      value: 'using PechaKucha at school as a teacher',
      hubspot_value: 'Using PechaKucha at your school as a teacher'
    },
    {
      label: 'Using PechaKucha at work',
      value: 'using PechaKucha at work',
      hubspot_value: 'Using PechaKucha at work'
    },
    {
      label: 'No thanks',
      value: 'none',
      //hubspot_value: 'No thanks'
    }
  ];

  /*
  const occupation_categories = [
    {
      label: 'I am a Student',
      value: 'student',
      //hubspot_value: 'Student'
    },
    {
      label: 'I am a Teacher (K-12)',
      value: 'teacher (k-12)',
      hubspot_value: 'Teacher (k-12)'
    },
    {
      label: 'I am a Professor',
      value: 'professor',
      hubspot_value: 'Professor'
    },
    {
      label: 'I am a Business Manager',
      value: 'business manager',
      hubspot_value: 'Business Manager'
    },
    {
      label: 'I am a Business Executive',
      value: 'business executive',
      hubspot_value: 'Business Executive'
    },
    {
      label: 'Other',
      value: 'other',
      //hubspot_value: 'Other'
    }
  ];
  */

  const { hubspot_response_data, isHubspotLoading, isHubspotError, handleHubspotSubmit } = HubspotForm({
    portalId: '6817434',
    formId: '075a6eef-557d-4389-a0a0-2edb25c05104'
  });

  function onDropdownCityChange (selectedCityOption) {
    console.log("onDropdownCityChange",selectedCityOption);
    setSelectedCityOption(selectedCityOption);
  }

  function handleTextChange (event) {
    //console.log("handleTextChange",event.target.id,event.target.value);
    setFormInfo({
      ...form_info,
      [event.target.id]: event.target.value
    });
  }
  
  function onOccupationCategoryChange (event) {
    console.log("onOccupationCategoryChange",event.target.id,event.target.value);
    setSelectedOccupationCategory(occupation_categories[event.target.value]);
  }

  async function saveChange () {

    if (step_name === 'name') {
      console.log("OnboardingModal saveChange",form_info);
      
      // make suire they entered something
      if (form_info.firstname.length < 1 || form_info.lastname.length < 1) {
        setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> Please fill out fields before saving</span>);
        return;
      }
      
      let patch_obj = {
        firstname: form_info.firstname,
        lastname: form_info.lastname
      };
      
      if (!context.user_info.friendly_url) {
        patch_obj.friendly_url = slugify(`${form_info.firstname} ${form_info.lastname}`);
      }
      
      setLoading(true);
      setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
      await axios.patch(`${apiUrl}users/${context.user_info.entity_uuid}`,patch_obj);
      
      context.setUserInfo({
        ...context.user_info,
        ...patch_obj
      });
      
      /*
      setUserInfo({
        ...user_info,
        firstname: form_info.firstname,
        lastname: form_info.lastname
      })
      */
      
      setMessage(<span style={{ color: 'green', fontSize: 'smaller' }}> Changes Saved</span>);
      //setLoading(false);
    } else if (step_name === 'city') {
      console.log("OnboardingModal saveChange",selected_city_option);
      if (!selected_city_option.value) {
        setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> Please fill out fields before saving</span>);
        return;
      }
      let patch_obj = {
        'locations.audience': [
          {
            entity_uuid: selected_city_option.value,
            xref_data: {
              resident_integer: 1
            }
          }  
        ]
      }
      setLoading(true);
      setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
      await axios.patch(`${apiUrl}users/${context.user_info.entity_uuid}`,patch_obj);
      
      context.setUserInfo({
        ...context.user_info,
        resident_locations: patch_obj
      });
      
      setMessage(<span style={{ color: 'green', fontSize: 'smaller' }}> Changes Saved</span>);
      //setLoading(false);
    } else if (step_name === 'occupation_category') {
      console.log("OnboardingModal saveChange",selected_occupation_category);
      if (!selected_occupation_category.value) {
        setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> Please select an interest before saving</span>);
        return;        
      }
      
      // save to PK
      let patch_obj = {
        //occupation_category: selected_occupation_category.value
        interest_category: selected_occupation_category.value
      }
      setLoading(true);
      setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
      await axios.patch(`${apiUrl}users/${context.user_info.entity_uuid}`,patch_obj);
      
      context.setUserInfo({
        ...context.user_info,
        ...patch_obj
      });
      
      /*
      // send to hubspot
      if (selected_occupation_category.hubspot_value) {

        let field_data_object = {
          firstname: context.user_info.firstname,
          lastname: context.user_info.lastname,
          email: context.user_info.email,
          'what_best_describes_your_role_': selected_occupation_category.hubspot_value
        }
  
        handleHubspotSubmit(field_data_object);
      }
      */
      
      setMessage(<span style={{ color: 'green', fontSize: 'smaller' }}> Changes Saved</span>);
    }
    //setupForm();
  }
  
  useEffect(() => {
    console.log("OnboardingModal context changed");
    setupForm();
  }, [...Object.values(context)]);
  
  async function setupForm() {
    setLoading(true);
    if (!context.user_info.firstname || !context.user_info.lastname) {
      setFormInfo({
        firstname: context.user_info.firstname || '',
        lastname: context.user_info.lastname || ''
      });
      setStepName('name');
    } else if (!context.user_info.resident_locations || context.user_info.resident_locations.length === 0) {
      await setupCities();
      setStepName('city');
    } else if (!context.user_info.interest_category) {
      //setMessage(<React.Fragment></React.Fragment>);
      setStepName('occupation_category');
    
    /*
    } else if (!context.user_info.avatar_image_url) {
      
    } else if (!context.user_info.favorite_categories || context.user_info.favorite_categories.length === 0) {
    */
    } else {
      // no more work to do!
      props.onHide();
    }
    setLoading(false);
  }

  async function setupCities () {
    
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let tmp_city_options = [];
    let latitude = 0;
    let longitude = 0;
    try {
      let geo_data = await geoLocation(); // ask browser for location
      console.log("Got browser geo_data",geo_data);
      latitude = geo_data.latitude;
      longitude = geo_data.longitude;
    } catch (err) {
      // we did not get user's lat/lon from browser - that is ok
      console.log("Did NOT get browser geo_data :(");
    }
    
    let [locations_response] = await Promise.all([
      axios.get(`${searchUrl}locationsearch?coordinates_lat=${latitude}&coordinates_lon=${longitude}&radius=20038`)
    ]);
    let locations_array = locations_response.data.search_query_results.map((data) => data.entity_info);
    
    for (let location_obj of locations_array) {
      let tmp_city_option = {
        label: location_obj.city_name.trim()+', '+location_obj.country,
        value: location_obj.entity_uuid
        //entity_uuid
      }
      tmp_city_options.push(tmp_city_option);
    }

    // first one will be closest to user
    setSelectedCityOption(tmp_city_options[0]);

    // now sort by city name
    tmp_city_options = tmp_city_options.sort((a, b) =>
      a.label.localeCompare(b.label, "en", { sensitivity: "base" })
    );
    //console.log("tmp_city_options",tmp_city_options);
    setCityOptions(tmp_city_options);
    
    setMessage(<React.Fragment></React.Fragment>);
    setLoading(false);
  }

  // on mount
  useEffect(() => {
    console.log("OnboardingModal useEffect props.show");

    if (!context.user_info) {
      return;
    }
    
    setupForm();
    
    const fetchData = async () => {
      //console.log("OnBoardingModal fetching locations");
    };
 
    //fetchData();
  }, [props.show]);

  function checkForEnter (event) {
    //console.log("checkForEnter",event.key);
    setMessage(<span>&nbsp;</span>);
    if (event.key === 'Enter') {
      saveChange();
    }
  }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Welcome to PechaKucha.com!<br/>
          <span style={{ fontSize: "70%", color: "darkgray" }}>Please take a moment to complete your user profile</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactTooltip />
        <Container>
          <Row>
            <Col>
              { step_name === 'name' && !loading &&
                <React.Fragment>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text>First and Last name</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      placeholder={'First Name'}
                      defaultValue={context.user_info.firstname}
                      onChange={handleTextChange}
                      id='firstname'
                    >
                    </FormControl>
                    <FormControl
                      placeholder={'Last Name'}
                      defaultValue={context.user_info.lastname}
                      onChange={handleTextChange}
                      id='lastname'
                      onKeyPress={checkForEnter}
                    >
                    </FormControl>
                  </InputGroup>
                </React.Fragment>
              }
              { step_name === 'city' && !loading &&
                <React.Fragment>
                  <span style={{ fontSize: "90%", color: "black" }}>Select the PechaKucha City closest to you</span>
                  <Select
                    styles={{ menuPortal: base => ({ ...base, fontSize: "smaller", zIndex: 9999 }) }}
                    menuPortalTarget={document.querySelector('body')}
                    className='cities_dropdown_menu'
                    classNamePrefix=''
                    value={selected_city_option}
                    onChange={onDropdownCityChange}
                    options={city_options}
                  />
                </React.Fragment>
              }
              { step_name === 'occupation_category' && !loading &&
                <React.Fragment>
                  <span style={{ fontSize: "90%", color: "black" }}>Interested in learning more about any of the following:</span>
                  {
                    occupation_categories.map((occupation_category,index) => {
                      return (
                        <FormCheck
                          key={occupation_category.value}
                          custom
                          type='radio'
                          label={occupation_category.label}
                          value={index}
                          name='selected_occupation_category_index'
                          id={`occupation_category-radio-${index}`}
                          onChange={onOccupationCategoryChange}
                          //id={`disabled-custom-${type}`}                      
                        />
                      );
                    })
                  }
                </React.Fragment>
              }
              
              {message}
            </Col>
            
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        { loading &&
          <ActivityIndicator theme="button-Status-Loader" />
        }
        <Button className="modal_button_white" onClick={props.onHide}>Maybe Later</Button>
        <Button
          className="modal_button"
          onClick={() => saveChange()}
          disabled={loading}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default OnboardingModal;